import React, { useState } from 'react';
import { difficultyLabel, plainTitle } from './puzzleText';

const CASE_FILE_URL = 'https://jerryevanoff.com/case-file';

// Used when a case has no share teaser of its own.
export const DEFAULT_TEASER = 'Three suspects. One slipped up.';

// One mark per hint spent, then how it ended. Says how the game went without saying anything about the case.
const resultLine = ({ wasCorrect, hintsUsed, points }) => {
  const marks = '💡'.repeat(hintsUsed) + (wasCorrect ? '✅' : '❌');

  if (!wasCorrect) {
    return `${marks} this one got me`;
  }

  const how = hintsUsed === 0 ? 'solved clean' : `solved with ${hintsUsed} hint${hintsUsed === 1 ? '' : 's'}`;

  return `${marks} ${how} · ${points} pt${points === 1 ? '' : 's'}`;
};

// Teases the mystery and brags a little, but never reveals the killer, the clue, or the solution.
export const shareText = ({ title, teaser, difficulty, wasCorrect, hintsUsed, points, streak }) => {
  const streakPart = streak > 1 ? ` · 🔥 ${streak}-week streak` : '';
  const dare = wasCorrect ? 'Think you can out-sleuth me?' : 'Avenge me.';

  return [
    `🔎 ${plainTitle(title)}`,
    teaser || DEFAULT_TEASER,
    `${difficultyLabel(difficulty)} · ${resultLine({ wasCorrect, hintsUsed, points })}${streakPart}`,
    dare
  ].join('\n');
};

const ShareButton = ({ title, teaser, difficulty, wasCorrect, hintsUsed, points, streak = 0 }) => {
  const [copied, setCopied] = useState(false);
  const text = shareText({ title, teaser, difficulty, wasCorrect, hintsUsed, points, streak });

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ text, url: CASE_FILE_URL });
        return;
      } catch (error) {
        // Cancelled or unsupported mid-call: fall through to copy.
      }
    }

    try {
      await navigator.clipboard.writeText(`${text} ${CASE_FILE_URL}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      // Clipboard denied: nothing more we can do without showing a fallback text box.
    }
  };

  return (
    <div className="cf-share">
      <button type="button" className="cf-cta cf-share-btn" onClick={handleShare}>
        {copied ? 'Copied — go brag!' : 'Share your result (no spoilers)'}
      </button>
    </div>
  );
};

export default ShareButton;
